import DialogContentText from "@mui/material/DialogContentText";
import React, { useState, useEffect } from "react";

import GenericModal from "../modal-closebtn";
import GenericSnackbar from "../snackbar/generic-snackbar";

const GenericDeleteModal = ({
  deleteAction,
  handleDialogClose,
  itemToRemove,
  history,
  redirectTo,
  clearDelete,
  deleteSuccess,
  deleteError,
  deleteConfirmationText,
  deleteBtnConfirmText,
  deleteBtnCancelText,
  deleteTitle,
  selectorSuccess,
  selectorError,
}) => {
  const [openDialog, setOpenDialog] = useState(false);

  useEffect(() => {
    setOpenDialog(true);
  }, []);

  const handleCloseDialog = () => {
    setOpenDialog(false);
    handleDialogClose();
  };

  const handleDelete = () => {
    deleteAction({ id: itemToRemove });
  };

  const backToList = () => {
    history.push(redirectTo);
  };

  const handleCloseSnackBar = () => {
    clearDelete();
    selectorSuccess && backToList();
  };

  return (
    <>
      <GenericModal
        title={deleteTitle}
        handleSubmit={handleDelete}
        handleClose={handleCloseDialog}
        btnActionTitle={deleteBtnConfirmText}
        btnCancelTitle={deleteBtnCancelText}
        size="xs"
        open={openDialog}
      >
        <DialogContentText
          className="text-center"
          style={{ padding: "5%" }}
          id="alert-dialog-description"
        >
          {deleteConfirmationText}
        </DialogContentText>
      </GenericModal>

      {selectorSuccess && (
        <GenericSnackbar
          success={true}
          message={deleteSuccess || selectorSuccess}
          handleClose={handleCloseSnackBar}
          duration={1000}
        />
      )}
      {selectorError && (
        <GenericSnackbar
          error={true}
          message={deleteError || selectorError}
          handleClose={handleCloseSnackBar}
          duration={4000}
        />
      )}
    </>
  );
};

export default GenericDeleteModal;
